"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clickedMainArtworkGrid = void 0;

var _Schema = require("../../Schema");

/**
 *  A user clicks an artwork in the main artowrkGrid (web)
 *
 * @example
 * ```
 * clickedMainArtworkGrid({
 *   contextPageOwnerType: OwnerType.artist,
 *   contextPageOwnerId: "5359794d2a1e86c3741001f8",
 *   contextPageOwnerSlug: "andy-warhol",
 *   destinationPageOwnerId: "5359794d1a1e86c3740001f7",
 *   destinationPageOwnerSlug: "andy-warhol-skull",
 * })
 * ```
 */
const clickedMainArtworkGrid = ({
  contextPageOwnerType,
  contextPageOwnerId,
  contextPageOwnerSlug,
  destinationPageOwnerId,
  destinationPageOwnerSlug
}) => {
  return {
    action: _Schema.ActionType.clickedMainArtworkGrid,
    context_module: _Schema.ContextModule.artworkGrid,
    context_page_owner_id: contextPageOwnerId,
    context_page_owner_slug: contextPageOwnerSlug,
    context_page_owner_type: contextPageOwnerType,
    destination_page_owner_id: destinationPageOwnerId,
    destination_page_owner_slug: destinationPageOwnerSlug,
    destination_page_owner_type: _Schema.OwnerType.artwork,
    type: "thumbnail"
  };
};

exports.clickedMainArtworkGrid = clickedMainArtworkGrid;